export const mapTimeSlotsMatrix = timeSlots => {
  let selectionMatrix;

  timeSlots.forEach(x => {
    selectionMatrix = { [x.id]: true, ...selectionMatrix };
  });

  const mappedMatrix = Object.assign({}, ...selectionMatrix);
  mappedMatrix[0] = selectionMatrix;
  return mappedMatrix;
};

export const mapActivities = treatmentInstances => {
  let activityModel = {};
  const activitiyList = [];

  treatmentInstances.map(x =>
    x.treatmentInstanceActivities.forEach(y => {
      activityModel = {
        treatmentId: x.treatmentId,
        id: y.id,
        name: y.name,
        duration: y.duration,
      };
      activitiyList.push(activityModel);
    }),
  );

  return activitiyList.flat();
};
